import React from 'react';


class Load extends React.Component {

    render(){
        return (
                 <div className="d-flex align-items-center justify-content-center p-5 h-100">
                      <div className="spinner-border text-info" role="status">
                          <span className="sr-only">Loading...</span>
                      </div>
                 </div>
        );
    }
}

export default Load;



